<template>
  <div class="modal">
    <header>
      <div class="title">
        <div
            v-if="icon"
            class="icon">
          {{ icon }}
        </div>
        <h1>{{ title }}</h1>
      </div>
      <button
          v-if="!hideCloseButton"
          class="close"
          @click="$modal.dismiss">
        <div class="icon">close</div>
      </button>
    </header>
    <main>
      <slot/>
    </main>
    <footer v-if="$slots.footer">
      <slot name="footer"/>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'Modal',
  props: {
    icon: String,
    title: String,
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.modal {
  background: $dark-gray-700;
  border-radius: 0.375rem;
  box-shadow: 0 0 1rem 0 rgba(0,0,0,0.8);
  z-index: 101;
  overflow: hidden;
  max-width: 40%;
  min-width: 16rem;

  header {
    display: flex;
    height: 3rem;
    justify-content: space-between;
    align-items: center;
    padding: 0.25rem;

    .title {
      align-items: center;
      display: flex;
      margin-left: 0.25rem;

      .icon {
        margin-left: 0.25rem;
      }

      h1 {
        font-size: 1.125rem;
        font-weight: 400;
        margin-left: 0.5rem;
      }
    }

    button.close {
      background: none;
      border: none;
      color: $text;
      padding: 0.5rem;
      outline: none;

      .icon {
        transition: color .2s;
      }

      &:hover {
        color: $primary-400;
      }

      &:active {
        color: $primary-600;
      }
    }
  }

  main {
    padding: 0.5rem 0.625rem;
  }

  footer {
    display: flex;
    justify-content: center;
    padding: 0.25rem;

    button {
      min-width: 25%;
    }
  }
}
</style>
